import CurvesRadial from "~/components/curvesRadial"

export default class RadialAcrossModels extends Component {
  render() {
    const { data } = this.props

    //const opacities = { mixed3a: 0.35, mixed3b: 0.35, mixed4a: 0.35 }

    const count = data.length
    const size = window.innerWidth / count - 150
    const padding = {
      conv2d2: 10,
      mixed3a: 8,
    }

    const blobs = {
      conv2d2: (
        <Text width={size} marginTop={20}>
          Conv2d2 is the second convolutional layer in InceptionV1. Its curves
          neurons primarily respond to one direction but also respond to the
          opposing direction.
        </Text>
      ),
      mixed3a: (
        <Text width={size} marginTop={20}>
          The curve neurons of mixed3a have become more specialized, but still
          activate to the opposing angle of the peak activation.
        </Text>
      ),
      mixed3b: (
        <Text width={size} marginTop={20}>
          The layer mixed3b is the curve neurons we have focused on during this
          article. These neurons are selective but still collectively cover the
          whole range of angles.
        </Text>
      ),
      mixed4a: (
        <Text width={size} marginTop={20}>
          The last layer with curve neurons, mixed4a develops a few large curve
          neurons. Strangely, none have filled the bottom of the circle.
        </Text>
      ),
    }

    console.log("across data is", data)

    return (
      <Surface
        flexFlow="row"
        width={window.innerWidth - 200}
        justifyContent="space-between"
      >
        {data.map(props => (
          <Surface>
            <Text fontSize={30} fontWeight={700} marginBottom={10}>
              {props.model.split("_")[0]}
            </Text>
            <CurvesRadial
              {...props}
              model={props.model.toLowerCase().split("_")[0]}
              neuronPadding={padding[props.layer] || 2}
              size={size}
              fillOpacity={0.4}
              orientationType={"max"}
            />
            {blobs[props.model]}
          </Surface>
        ))}
      </Surface>
    )
  }
}
